import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';
import SelectUsers from '../../general-components/select-users';
import { InvitedPresenter } from '../../app-entry/producer/meeting-modal';
import { ChipContext } from '../../../contexts/generated-content/content-chip-context';
import useProfile from '../../../hooks/use-profile';

interface OwnProps {
	shown: boolean;
	disabled?:boolean;
}

export default function PresenterDropdown(props: OwnProps) {
	const { disabled = false } = props;
	const invitations = useSelector((s: GreenroomState) => s.InvitationsReducer.invitations);
	const {getMaskedProfileById} = useProfile({});
	const [selected, setSelected] = useState<InvitedPresenter[]>([]);
	const {attachUser, chipsetUserId} = useContext(ChipContext)

	const chipsetProfile = React.useMemo(() => {
		if (!chipsetUserId) {
			return null;
		} 
		
		const inviteMatchingChipset = invitations.find((i) => i.profile?.gr_user === chipsetUserId);

		return inviteMatchingChipset?.profile ?? null;
	}, [chipsetUserId, invitations]);

	useEffect(() => {
		if (chipsetProfile === null) {
			// none selected
			setSelected([]);
		} else if (!selected[0] || chipsetProfile?.gr_user !== selected[0]?.gr_user) {
			// chipset changed
			setSelected([{...chipsetProfile, role: 'presenter'}]);
		}
	}, [chipsetProfile])

	if (!props.shown) return null;
	
	const onChange = (invs: InvitedPresenter[]) => {
		if (invs[0]?.gr_user) {
			setSelected([invs[0]]);
			attachUser(invs[0].gr_user);
		} else {
			setSelected([]);
			attachUser(null);
		}
	}

	const profiles = Array.from(new Map(
		invitations.map((i) => [
			i.profile.gr_user, 
			{...i.profile, role: 'presenter'}
		])
	).values());

	const potentialMask = selected[0]?.gr_user ? getMaskedProfileById(selected[0].gr_user) : null;
	const maskedSelected = potentialMask ? [{...potentialMask, role: 'presenter'} as InvitedPresenter] : selected;

	return <SelectUsers
		onChange={onChange}
		selected={maskedSelected}
		users={profiles}
		single={true}
		disabled={disabled}
	/>;
}
